module.exports = __webpack_public_path__ + "static/media/ic-code.521477fe.svg";